export default __webpack_public_path__ + "static/media/export.4dfba1d1.svg";